import { ReadonlyRepositoryObjectService } from '@softline/core';
import { Product } from '@softapps/wws/core';
import { computed, inject, Injectable } from '@angular/core';
import { routeParamAsNumber } from '@softline/application';
import { ProductRepository } from '../repositories/product.repository';
import { ProductQuery } from '../types/product.query';

@Injectable()
export class ProductService extends ReadonlyRepositoryObjectService<
  Product,
  Product,
  ProductQuery
> {
  productId = routeParamAsNumber('id');
  override params = computed(() => {
    return { id: this.productId() ?? undefined };
  });

  constructor() {
    super(inject(ProductRepository));
  }

  protected override getValue(result: Product): Product {
    return result;
  }
}
